export default __webpack_public_path__ + "static/media/bg-top-m.219027a3.png";